import React, { useEffect, useReducer, useState } from "react"
import { ServerRequestProtected } from "../../../../utils/ServerDataRequest"
import { enumUtil } from '../../../../utils/Enum'
import Loader from "../../../shared/Loader/Loader"
// import Table from "../../../Shared/Table"
// import SearchHeader from "../../../Shared/SearchHeader"
// import GridColumnHeader from "../../Shared/GridColumnHeader"
// import handleCopyText  from "../../../../utils/CopyText"
import isNull from "../../../../utils/NullChecking"
import { connect, useDispatch } from "react-redux"
import AddnewTimeLine from "./AddnewTimeLine"
import usePagination from "../../../../customhooks/usePagination"
import GridColumnHeader from "../../../Setup/Shared/GridColumnHeader"
import Table from "../../../Setup/Shared/Table"
import SearchHeader from "../../../Setup/Shared/SearchHeader"
import handleCopyText from "../../../shared/CopyData"
import SuperSearchList from "../../../shared/SuperSearch/SuperSearchList"
import { useSelector } from "react-redux"
import HandleStatus from "../../../shared/HandleStatus"
import AddNewAppointment from "../../../Scheduler/AddNewAppointment"
import AmountFormatter from "../../../../utils/AmountFormatter"
import CollectCopay from "../../../shared/CopayCollection/CollectCopay"
import clearicon from "../../../../assets/img/Vector.svg"
import AddNewTask from "../../../Home/TaskManagement/AddNewTask"
import { AppointmentTypes } from "../../../../utils/Constants"
import CalendaRangeInput from "../../../General/CalendarRangeInput"
import { GeneralDropDowns } from "../../../../actions/GeneralPatientActions"
import { IconAddPlus, ViewEncounterIcon } from "../../../shared/IconsComponent/icons"
import EncounterMenu from "../../../Encounter Menu/EncounterMenu"
import { MainTabContentActiveTab, MainTabContentTabList } from "../../../../actions/SidebarAction"
import EncounterMenuSearch from "../../../Encounter Menu/EncounterMenuSearch"
import { TabActionEncounterMenu } from "../../../../actions/EncounterMenuActions"
import CustomUseRef from "../../../shared/DropDown/CustomUseRef"
const TimeLine = (props) => {
    let PateintIDR = useSelector(state => state.Open_Patient_Tab.find((pt) => pt.active === true));
    if (PateintIDR && PateintIDR.data) {
        PateintIDR = PateintIDR.data.id;
    }
    let DropDowns = useSelector(state => state.GeneralDropDownsReducer);
    let TypeDropDownOptions = [
        { value: 'Appointments', display: 'Appointments' },
        { value: 'Forms', display: 'Forms' },
        { value: 'Tasks', display: 'Tasks' },
        // { value: 'Encounter', display: 'Encounter' },


    ]
    const API_URL = enumUtil.controller.General
    const API_URL_Patient = enumUtil.controller.Patient
    const { type, Settings } = { ...props }
    const { paginationSection, PerPage, PageNo, TotalPages, handlePageClick, PreviousPage, NextPage, handleFingByCreteria, setTotalPages, handleSelectData } = usePagination(Settings.PaginationDefaultRows);
    const [templateTypeDispay, setTemplateTypeDisplay] = useState('Appointments')
    const [templateType, setTemplateType] = useState('Appointments')
    const [is, setIs] = useState(true);

    const [appointmentType, setAppointmentType] = useState({
        display: 'All',
        value: ''
    })
    const [isOpenWriteOff, setisOpenWriteOff] = useState(false)
    const [WriteOffData, setWriteOffData] = useState([]);
    const [WriteOffCode, setWriteOffCode] = useState();
    const [searchParam, setSearchParam] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [isClose, setIsClose] = useState();
    const [show, setShow] = useState(false);
    const [totalCounts, setTotalCounts] = useState(false)
    const [PatientID, setPatientID] = useState(null);
    const [AppointmentDateFilter, setAppointmentDateFilter] = useState({
        'AppointmentDateFrom': null,
        'AppointmentDateTo': null
    })
    const [statusArray, setStatusArray] = useState([]);
    let dispatch = useDispatch()

    ////////====GridColumnHeader=========//////////
    const [gridHeader, handleGridHeader] = useReducer((prev, next) => {
        return { ...prev, ...next }
    }, { defaultData: '', activeSortIcon: '' })

    const getStatusDropDowns = () => {
        let saveModal = {
            "TableName": enumUtil.enumAPITableName.AppointmentStatus,
        }
        ServerRequestProtected(API_URL_Patient + '/AppointmentStatusDropDown', 'post', saveModal)
            .then((response) => {
                setStatusArray(response)
                dispatch(GeneralDropDowns({ ...DropDowns, AppointmentNextStatus: response }))
            }).catch((error) => {
                setStatusArray([])
            })
    }
    const LoadData = (searchParam) => {
        setIsLoading(true)
        setWriteOffData([])
        const SearchPageNo = !searchParam
        ServerRequestProtected(API_URL + "/FindByMultipleCriteria", 'post', {
            "TableName": enumUtil.enumAPITableName.PatientTimeLine,
            "ID": PateintIDR,
            "SearchCriteria": {
                "Peram": templateType,
                "Search": searchParam,
                'IsGroupAppointment': templateTypeDispay === 'Appointments' ? appointmentType.value : '',
                'AppointmentDateFrom': AppointmentDateFilter.AppointmentDateFrom ? AppointmentDateFilter.AppointmentDateFrom : null,
                'AppointmentDateTo': AppointmentDateFilter.AppointmentDateTo ? AppointmentDateFilter.AppointmentDateTo : null
            },
            "PerPage": PerPage,
            "PageNo": SearchPageNo ? PageNo : 1,
        }).then((response) => {
            setIsLoading(false)
            handleGridHeader({ defaultData: response.Rows })
            setWriteOffData(response.Rows)
            let rowCount = response?.Rows?.length;
            setTotalCounts(rowCount)
            setTotalPages(response.count.NumOfPages);
        }).catch((error) => {
            setTotalCounts(0)
            setIsLoading(false)
        })
    }

    const SearchByParam = () => {
        if (!isNull(searchParam)) {
            // setPageNo('1')
            LoadData(searchParam)
        } else {
            LoadData()
        }
    }
    const SearchOnEnter = (e) => {
        if (e.key === "Enter") {
            SearchByParam(searchParam, "searchParam")
        }
    }
    useEffect(() => {
        LoadData(searchParam);
    }, [PerPage, PageNo, isClose, templateType])
    const AddWriteOff = (ID) => {
        setisOpenWriteOff(true)
        setWriteOffCode(ID)
    }
    const CloseWiteOff = () => {
        setisOpenWriteOff(false)
    }
    const DeleteWriteOff = () => {
        setisOpenWriteOff(false)
        setIsClose((Math.random()));
    }
    const [copiedText, setCopiedText] = useState({});
    const handleCopy = (row, type) => {
        let name = `${row}-${type}`;
        console.log("Name", name)
        handleCopyText(type);
        setCopiedText({ ...copiedText, [name]: true });
        setTimeout(() => {
            setCopiedText({ ...copiedText, [name]: false });
        }, 300)
    }
    // appointment popup
    const [AppointmentID, setAppointmentID] = useState(null);
    const [isBlocked, setIsBlocked] = useState(false);
    const [showEvents, setShowEvents] = useState(false);
    const [LocationID, setLocationID] = useState('')
    const [ProviderID, setProviderID] = useState('')
    const [AppointmentDate, setAppointmentDate] = useState(null)
    const handleNewAppointment = (ID, AppointmentStatus, locID, proID, patID, date) => {
        if (AppointmentStatus === "Blocked") {
            setIsBlocked(true);
        } else {
            setIsBlocked(false);
        }
        setLocationID(locID + "")
        setProviderID(proID + "")
        setPatientID(patID + "")
        setAppointmentID(ID);
        setAppointmentDate(date)
        setShowEvents(true);
    }
    const handleOnClose = () => {
        setShowEvents(false);
        setIsBlocked(false);
        setLocationID('')
        setProviderID('')
        setPatientID('')
        setAppointmentID(null);
        setAppointmentDate(null)
    }
    let appointmentPopUp = "";
    if (showEvents) {
        appointmentPopUp = <AddNewAppointment
            AppointmentID={AppointmentID}
            showEvents={showEvents}
            handleOnClose={handleOnClose}
            isBlocked={isBlocked}
            getAppointments={() => ('')}
            providerID={ProviderID}
            locationID={LocationID}
            PatientID={PatientID}
            choosenDate={AppointmentDate}
        />;

    }
    // copay
    const [isOpenCopay, setIsOpenCopay] = useState(false)
    const [PatientAppointmentID, setPatientAppointementID] = useState(0)
    const handleOpenCopay = (data) => {
        setIsOpenCopay(true)
        setPatientID(data.PatientID);
        setPatientAppointementID(data.PatientAppointmentID);

    }
    const OnCloseCopay = () => {
        setIsOpenCopay(false);
        LoadData()
    }
    let CopayPopup = '';
    if (isOpenCopay) {
        CopayPopup = <CollectCopay isOpenCopay={isOpenCopay} OnCloseCopay={OnCloseCopay} PatientID={PatientID} type={'PatientAppointment'} ID={PatientAppointmentID} />
    }
    const [TaskID, SetTaskID] = useState(0)
    const [Isopen, setIsopen] = useState(false);
    const Addnew = (TaskID) => {
        setIsopen(true)
        SetTaskID(TaskID)
    }
    const close = () => {
        setIsopen(false);
    }
    let state = useSelector(state => state.SidebarList)
    const handleActive_SubTab = (key, name, component, right) => {
        let arr = state
        let dynamicTabs = [...arr]
        const newTabObject = {
            key: key,
            name: name,
            component: component,
            right: right,
            time: new Date(),
        }
        const isTabExist = dynamicTabs.filter((tab) => {
            return tab.name === name
        })
        if (!(isTabExist && isTabExist.length > 0)) {
            dynamicTabs = [...dynamicTabs, newTabObject]
            dispatch(MainTabContentTabList(dynamicTabs));
        }
        dispatch(MainTabContentActiveTab(key))
        // setOpenTab && setOpenTab('')
    }
    const handleOpenEncounter = (encounter, type) => {
        if (type === "New Encounter" || type === 'New AI Encounter') {
            handleActive_SubTab(9, 'Encounters', <EncounterMenu />, true)
            let obj = {
                active: true,
                key: 2,
                name: "EncounterMenu",
                data: {
                    name: "All Encounters",
                    id: 0,
                    component: <EncounterMenuSearch />,
                    setRecordsNum: null,
                    openedFor: type,
                    EncounterPopup: {
                        PatientName: encounter.FirstName,
                        EncounterDate: encounter?.AppointmentDate,
                        SeenBy: encounter?.ProviderID + "",
                        Facility: encounter?.LocationID + "",
                        PatientID: encounter.PatientID + "",
                        EncounterType: encounter?.EncounterTypeID ? encounter?.EncounterTypeID + "" : '',
                        NoteType: encounter?.NoteType + "",
                        PatientAppointmentID: encounter?.PatientAppointmentID + "",
                        EHRTemplateID: encounter?.EHRTemplateID ? encounter?.EHRTemplateID + "" : '',
                        IsSystemGenerated: encounter?.IsSystemGenerated + "",
                        IsGroupAppointment: encounter.IsGroupAppointment,
                        GroupIdentifier: encounter.GroupIdentifier
                    }
                },
            }
            console.log('objobjobj', obj);

            setTimeout(() => {
                dispatch(TabActionEncounterMenu(obj))

            }, 0);
        } else {
            handleActive_SubTab(9, 'Encounters', <EncounterMenu />, true)
            let obj = {
                active: true,
                key: 2,
                name: "Encounter Menu",
                data: {
                    name: `${encounter.FirstName} - ${encounter.EncounterDate}`,
                    id: encounter.EncounterID,
                    patid: encounter.PatientID,
                    type: encounter.NoteType,
                    time: new Date(),
                    groupEncounter: {
                        isGroupEncounter: encounter.IsGroupAppointment === "True" ? 'true' : 'false',
                        GroupIdentifier: encounter.GroupIdentifier ? encounter.GroupIdentifier : '',
                        showGroupNote: false
                    }
                },

            }
            setTimeout(() => {
                dispatch(TabActionEncounterMenu(obj))
            }, 0);
        }
    }
    const Appointmentcolumns = [
        {
            key: 'AppointmentStatus',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                headerName={'Status'} sortIcon={true} type={'string'} colKey={'AppointmentStatus'} data={WriteOffData} setData={setWriteOffData} />),
            resizable: true,
            renderCell: ({ row }) => {
                const StatusColor = row?.AppointmentStatus?.split(' ').join('-');
                return (
                    <p className={`pill ${StatusColor}`}>{row.AppointmentStatus}</p>
                )
            },
        },
        {
            key: 'AppointmentDate',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                headerName={'Date'} sortIcon={true} type={'date'} colKey={'AppointmentDate'} data={WriteOffData} setData={setWriteOffData} />),
            resizable: true,
            renderCell: ({ row }) => {
                return <div className="d-flex align-items-center justify-content-between gap-20">

                    <button className="btn  btn-link w-100 d-flex align-items-center gap-1" onClick={() => handleNewAppointment(row?.PatientAppointmentID, row?.AppointmentStatus, row.LocationID, row.ProviderID, row.PatientID, row.AppointmentDate)} >
                        {row.AppointmentDate}
                    </button>
                    <div className="d-flex align-items-center gap-1 min-w-35px justify-content-end">

                        {row?.IsGroupAppointment === 'True' ?
                            <i className="icon-group-pateint fs-13"></i>
                            : null}

                        {statusArray.filter(opt => (!["No Show", "Cancelled"].includes(opt.Status))).map(it => it.Status).includes(row?.AppointmentStatus)
                            && (!isNull(row?.EncounterID) && !isNull(row?.EncounterDate)) &&
                            <div className="app_tooltip right">
                                <span onClick={() => handleOpenEncounter(row)}><ViewEncounterIcon width={18} height={20} /></span>
                                <p className="tool_tip xsm_text text-light">View Encounter</p>
                            </div>}
                        {statusArray.filter(opt => (!["No Show", "Cancelled"].includes(opt.Status))).map(it => it.Status).includes(row?.AppointmentStatus)
                            && (isNull(row?.EncounterID) || isNull(row?.EncounterDate)) && ((!row?.AppointmentDate || new Date(row?.AppointmentDate) <= new Date())) &&

                            <div className="ar-create-encounter_tooltip lh-normal">
                                <span className="click-context" onClick={(e) => handleShowContextMenu(e, row?.PatientAppointmentID)}><IconAddPlus /></span>

                                <CustomUseRef onClose={closeDropdown} IsActivePtPayments={showContextMenu} type={'menuButton'} className={'position-static'}>
                                    <div className={`context-menu d-flex flex-column gap-1 ${showContextMenu === row?.PatientAppointmentID && 'Show-context'}`}>
                                        <div className="d-flex align-items-center gap-2 px-2" onClick={() => handleOpenEncounter(row, "New Encounter")}>
                                            <i className="icon-plus-feesetup fs-11"></i>
                                            <p className='text fs-11 font-m'>Create  Encounter</p>
                                        </div>
                                        <div className="d-flex align-items-center gap-2 px-2" onClick={() => handleOpenEncounter(row, "New AI Encounter")}>
                                            <i className="icon-ai-encounter fs-14"></i>
                                            <p className='text fs-11 font-m'>Create AI Encounter</p>
                                        </div>
                                    </div>
                                </CustomUseRef>

                            </div>
                        }
                    </div>


                </div>
            },
        },
        {
            key: 'AppointmentStartTime',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                headerName={'Time'} sortIcon={true} type={'string'} colKey={'AppointmentStartTime'} data={WriteOffData} setData={setWriteOffData} />),
            resizable: true,
        },
        {
            key: 'ProviderName',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                headerName={'Provider'} sortIcon={true} type={'string'} colKey={'ProviderName'} data={WriteOffData} setData={setWriteOffData} />),
            resizable: true,
        },
        {
            key: 'AppointmentType',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                headerName={'Type'} sortIcon={true} type={'string'} colKey={'AppointmentType'} data={WriteOffData} setData={setWriteOffData} />),
            resizable: true,
        },
        {
            key: 'ChiefComplain',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                headerName={'Chief Complaint'} sortIcon={true} type={'string'} colKey={'ChiefComplain'} data={WriteOffData} setData={setWriteOffData} />),
            resizable: true,
        },
        {
            key: 'Confirmation',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                headerName={'Confirmation'} sortIcon={true} type={'string'} colKey={'Confirmation'} data={WriteOffData} setData={setWriteOffData} />),
            resizable: true,
            renderCell: ({ row }) => {
                return <div className="za-denied-status position-relative d-flex">
                    <div className={`hk-tableCell d-flex flex-column`} >
                        {row?.IsAppointmentConfirmed === "True" ? <p className="Paid ar-status-clm text font-sb"> Confirmed </p> :
                            <> - </>}
                    </div>
                    {row?.IsAppointmentConfirmed === "True" ?
                        <div className='xsm_text text-light tool_tip confirmation-popup'>
                            <p className="heading fs-9 drk-green-clr">Confirmation Method</p>
                            <div className="d-flex flex-column gap-1 ">
                                <p className="text fs-9 ar-light-color br-bottom-1 za-br-clr pb-1">{row?.ConfirmationMethod}</p>
                                <div>
                                    <p className="heading fs-9 drk-green-clr">Notes</p>
                                    <p className="text fs-9 ar-light-color br-bottom-1 za-br-clr pb-1">{row?.ConfirmationNotes}</p>
                                </div>

                                <p className="heading fs-8 text-white updated">Updated By -
                                    {row?.ConfirmationMethod === 'Patient Responded via Email' ? 'N/A' : row?.UpdatedBy}
                                </p>
                                <p className="heading fs-8 text-white updated">Date - {row?.ConfirmationDate && row?.ConfirmationDate + " - "}  {row?.ConfirmationTime}</p>
                            </div>

                        </div> : <></>}
                </div>
            }
        },
        {
            key: 'Copay',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                headerName={'Copay'} sortIcon={true} type={'string'} colKey={'Copay'} data={WriteOffData} setData={setWriteOffData} />),
            resizable: true,
            renderCell: ({ row }) => {
                return <span>{!isNull(row.CopayPaid) ?
                    <span className="d-flex text-nowrap gap-1"><AmountFormatter amount={row.CopayPaid} />   -  <span className="text fst-italic font-m za-harlequen-green-clr">Paid</span></span>
                    : !isNull(row.Copay) ? <span className="d-flex gap-1 text-nowrap"><AmountFormatter amount={row.Copay} />
                        |  <a className="text fs-11 text-decoration-underline validate-color" onClick={() => handleOpenCopay(row)}>Collect</a></span> : '-'}</span>
            }
        },

    ]
    const Taskcolumns = [
        {
            key: 'Task',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                headerName={'Task'} sortIcon={true} type={'string'} colKey={'Task'} data={WriteOffData} setData={setWriteOffData} />),
            resizable: true,
            width: 75,
            renderCell: ({ row }) => {
                return (
                    <div className="d-flex align-items-center justify-content-between gap-10">
                        <p className="text cursor-pointer text-nowrap validation_message ar-hover-text lh-16 w-100" onClick={() => Addnew(row?.TaskID)}>{row?.Task}</p>
                    </div>
                )
            },
        },
        {
            key: 'Priority',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                headerName={'Priority'} sortIcon={true} type={'string'} colKey={'Priority'} data={WriteOffData} setData={setWriteOffData} />),
            resizable: true,
            minWidth: 75,
            width: 75,
            renderCell: ({ row }) => {
                return (
                    <div className="prioity m-auto d-flex align-items-center justify-content-center w-100">
                        <div className="app_tooltip right">
                            {row?.Priority === 'Urgent' ? <i className="icon-Vector-8"></i> :
                                row?.Priority === 'High' ? <i className="icon-Vector-9"></i> :
                                    row?.Priority === 'Normal' ? <i className="icon-Vector-10"></i> :
                                        row?.Priority === 'Low' ? <i className="icon-flag-2-svgrepo-com-1 fs-15"></i> :
                                            row?.Priority === 'Clear' ? <img src={clearicon} className="empty"></img> :
                                                <img src={clearicon} className="empty"></img>}
                            <p class="tool_tip xsm_text text-light">{row?.Priority}</p>
                        </div>
                    </div>
                )
            },
        },
        {
            key: 'AssigneeName',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                headerName={'Assignee'} sortIcon={true} type={'string'} colKey={'AssigneeName'} data={WriteOffData} setData={setWriteOffData} />),
            resizable: true,
        },
        {
            key: 'AssignedBy',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                headerName={'Assigned By'} sortIcon={true} type={'string'} colKey={'AssignedBy'} data={WriteOffData} setData={setWriteOffData} />),
            resizable: true,
        },
        {
            key: 'CreatedOn',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                headerName={'Created On'} sortIcon={true} type={'date'} colKey={'CreatedOn'} data={WriteOffData} setData={setWriteOffData} />),
            resizable: true,
        },
        {
            key: 'DueDate',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                headerName={'Due Date'} sortIcon={true} type={'date'} colKey={'DueDate'} data={WriteOffData} setData={setWriteOffData} />),
            resizable: true,
        },
        {
            key: 'Status',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                headerName={'Status'} sortIcon={true} type={'string'} colKey={'Status'} data={WriteOffData} setData={setWriteOffData} />),
            resizable: true,
            renderCell: ({ row }) => {
                return <p className={`status_bg pill ${row?.Status === 'Open' ? "open_bg" : row?.Status === 'In Review' ?
                    "In-Review" : row?.Status === 'Closed' ? "Paid" : row?.Status === 'In Progress' ? "in_progress" : ""}`}>
                    {row?.Status?.length > 0 ? row?.Status : <></>}
                </p>
            }
        },

    ]
    const Formscolumns = [
        {
            key: 'TemplateName',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                headerName={'Form'} sortIcon={true} type={'string'} colKey={'TemplateName'} data={WriteOffData} setData={setWriteOffData} />),
            resizable: true,
        },
        {
            key: 'TemplateType',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                headerName={'Type'} sortIcon={true} type={'string'} colKey={'TemplateType'} data={WriteOffData} setData={setWriteOffData} />),
            resizable: true,
        },
        {
            key: 'ProviderName',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                headerName={'Provider'} sortIcon={true} type={'string'} colKey={'ProviderName'} data={WriteOffData} setData={setWriteOffData} />),
            resizable: true,
        },

        {
            key: 'EnteredDate',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                headerName={'Sent Date'} sortIcon={true} type={'string'} colKey={'EnteredDate'} data={WriteOffData} setData={setWriteOffData} />),
            resizable: true,
        },

        {
            key: 'Status',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                headerName={'Status'} sortIcon={true} type={'string'} colKey={'Status'} data={WriteOffData} setData={setWriteOffData} />),
            resizable: true,
        },

    ]
    const Encountercolumns =
        [
            {
                key: 'EncounterDate',
                name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                    iconName={'icon-Icon-awesome-user-tie'} headerName={'Date'} sortIcon={true} type={'string'} colKey={'EncounterDate'} data={WriteOffData} setData={setWriteOffData} />),
                // renderCell: ({ row }) => {
                //     return (<button className="btn btn-link w-100" onClick={() => handleOpenEncounter(row)}>{`${row.EncounterDate}`}</button>)
                // },
                resizable: true,
            },
            {
                key: 'EncounterType',
                name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                    iconName={'icon-Icon-awesome-user-tie'} headerName={'Encounter Type'} sortIcon={true} type={'string'} colKey={'EncounterType'} data={WriteOffData} setData={setWriteOffData} />),
                renderCell: ({ row }) => {
                    return (<>{row.EncounterType}</>)
                },
                resizable: true,
            },
            {
                key: 'NoteType',
                name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                    iconName={'icon-Icon-awesome-user-tie'} headerName={'Note Type'} sortIcon={true} type={'string'} colKey={'NoteType'} data={WriteOffData} setData={setWriteOffData} />),
                renderCell: ({ row }) => {
                    return (<>{row.NoteType}</>)
                },
                resizable: true,
            },
            {
                key: 'SeenBy',
                name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                    iconName={'icon-Icon-awesome-user-tie'} headerName={'Provider'} sortIcon={true} type={'string'} colKey={'SeenBy'} data={WriteOffData} setData={setWriteOffData} />),
                renderCell: ({ row }) => {
                    return (<>{row.SeenBy}</>)
                },
                resizable: true,
            },
            {
                key: 'LocationName',
                name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                    iconName={'icon-Icon-awesome-user-tie'} headerName={'Location'} sortIcon={true} type={'string'} colKey={'LocationName'} data={WriteOffData} setData={setWriteOffData} />),
                renderCell: ({ row }) => {
                    return (<>{row.LocationName}</>)
                },
                resizable: true,
            },
            {
                key: 'Status',
                name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                    iconName={'icon-Icon-awesome-user-tie'} headerName={'Status'} sortIcon={true} type={'string'} colKey={'Status'} data={WriteOffData} setData={setWriteOffData} />),
                renderCell: ({ row }) => {
                    return (<>{row.EncounterStatus === 'Signed' ?
                        <p className='Paid heading font-m ar-status-clm'>Signed</p> :
                        row.EncounterStatus === 'Unsigned' &&
                        <p className='Not-Signed heading font-m ar-status-clm'>Unsigned</p>}</>)
                },
                resizable: true,
            },
            {
                key: 'UpdatedBy',
                name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                    iconName={'icon-card'} headerName={'Updated By'} sortIcon={true} type={'string'} colKey={'UpdatedBy'} data={WriteOffData} setData={setWriteOffData} />),
                resizable: true,
            },
            {
                key: 'UpdateDate',
                name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                    iconName={'icon-card'} headerName={'Updated Date'} sortIcon={true} type={'date'} colKey={'UpdateDate'} data={WriteOffData} setData={setWriteOffData} />),
                resizable: true,
            },
            {
                key: 'Action',
                name: (<GridColumnHeader iconName={''} headerName={'Action'} sortIcon={false} />),
                resizable: true,
                // renderCell({ row }) {
                //     const rowID = row.BillingDocumentID
                //     return (
                //     <>
                //         <div className="d-flex align-items-center gap-1 ar-billing_doc">
                //         <i className="icon-delete text-danger fs-12" onClick={() => handleDeleteGridModal(row?.EncounterID)}></i>
                //         </div>
                //     </>
                //     )
                // }
            },
            // {
            //     key: 'ChiefComplaint',
            //     name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
            //         iconName={'icon-Icon-awesome-user-tie'} headerName={'Chief Complaint'} sortIcon={true} type={'string'} colKey={'ChiefComplaint'} data={encountersData} setData={setWriteOffData} />),
            //     renderCell: ({ row }) => {
            //         return (<>{row.ChiefComplaint}</>)
            //     },
            //     resizable: true,
            // },
        ];
    let PopupScreen = "";
    if (isOpenWriteOff) {
        PopupScreen = <AddnewTimeLine isOpenWriteOff={isOpenWriteOff} onClose={CloseWiteOff} onDeleteRemark={DeleteWriteOff} WriteOffCode={WriteOffCode} />
    }
    const CardView = () => setShow(true);
    const TableView = () => setShow(false);
    const rowClass = () => { return "row-bg" }
    const handleExcel = () => { }
    const handlePdf = () => { }
    const handleFilter = () => { }
    const handleDelete = () => { }

    const handleSelectedDataa = (selectedData, name, type) => {
        setIs(true)
        if (type === 'client' && !isNull(selectedData)) {
            if (name === 'Type') {
                setTemplateTypeDisplay(selectedData.display)
                setTemplateType(selectedData.value)
            } else if (name === 'AppointmentType') {
                setAppointmentType({ display: selectedData.display, value: selectedData.value })
            }
        } else {
            if (name === 'Type') {
                setTemplateTypeDisplay('Appointments')
                setTemplateType('Appointments')
            }
            else if (name === 'AppointmentType') {
                setAppointmentType({ display: 'All', value: '' })
            }
        }
        return selectedData
    }
    const handleChange = (e) => {
        setIs(false)
        let { name, value } = e.target
        if (name === 'Type') {
            setTemplateTypeDisplay(value)
        } else if (name === 'AppointmentType') {
            setAppointmentType({ display: value, value: '' })
        }
    }
    const handleClearSearch = () => {
        setIs(true)
        setSearchParam('')
        setAppointmentType({ display: 'All', value: '' })
        setAppointmentDateFilter({
            'AppointmentStartDate': null,
            'AppointmentEndDate': null
        })
    }
    useEffect(() => {
        if (!isNull(props.Reload)) {
            let data = props.id
            data.map((item) => {
                if (item.key === 220) {
                    LoadData()
                }
            })
        }
    }, [props.Reload])
    useEffect(() => {
        getStatusDropDowns()
    }, [])

    let popupScreen = ""
    if (Isopen) {
        popupScreen = <AddNewTask IsOpen={Isopen} IsClosed={close} onDeleteTask={close} Task={TaskID} view={'MyTasks'} />
    }
    const [showContextMenu, setShowContextMenu] = useState(false);

    const handleShowContextMenu = (e, rowId) => {
        e.stopPropagation();
        setShowContextMenu(rowId);
    };

    const closeDropdown = () => {
        setShowContextMenu(false);
    };
    return (
        <React.Fragment>
            {PopupScreen}
            {popupScreen}
            {appointmentPopUp}
            {CopayPopup}
            <div className='container-fluid action-row br-clr ps-2 py-2'>
                <div className="row justify-content-between row-half">
                    <div className={templateTypeDispay === 'Appointments' ? 'col-4' : 'col-4'}>
                        <div className="input">
                            <div className='input-group hk-input-search'>
                                <input type="text" className='form-control fc-xs'
                                    placeholder='Search…'
                                    onChange={e => setSearchParam(e.target.value)}
                                    onKeyDown={SearchOnEnter}
                                    value={searchParam} />
                                {searchParam?.length > 0 ?
                                    <span className="input-group-text" id="basic-addon2" onClick={handleClearSearch}>
                                        <i className="bi bi-x"></i>
                                    </span> : <span className="input-group-text" id="basic-addon2" onClick={SearchByParam}>
                                        <i className="bi bi-search"></i>
                                    </span>}
                            </div>
                        </div>
                    </div>
                    {templateTypeDispay === 'Appointments' ?
                        <>
                            <div className="col-md-2 multipleSearch-rounded">
                                <SuperSearchList
                                    type="client"
                                    id='AppointmentType'
                                    name='AppointmentType'
                                    searchValue={appointmentType.display}
                                    data={AppointmentTypes}
                                    onChange={(e) => handleChange(e)}
                                    getSelectedData={handleSelectedDataa}
                                    is={is}
                                    icon={'Simple'}
                                    sup_btn='sup_btn'
                                    sup_inp='superSearchVisitInp'
                                    placeholder="Appointment Type"
                                />
                            </div>
                            <div className="col-md-2">
                                <CalendaRangeInput
                                    searchParam={AppointmentDateFilter}
                                    setSearchParam={setAppointmentDateFilter}
                                    defaultDates={null}
                                    options={['AppointmentDate']}
                                    label={false}
                                />
                            </div>
                            <div className="col-md-2">
                                <div className='btns-group-flex'>
                                    <button className='btn btn-orange btn-xs no-width rounded' onClick={() => LoadData(searchParam)}>Search</button>
                                    <div className='line-border'></div>
                                    <button className='btn btn-outline btn-xs no-width rounded' onClick={() => handleClearSearch()}>Clear</button>
                                </div>
                            </div>
                        </>
                        : null}
                    {/* <div className="col-4 ps-0"> */}
                    <div className='col-md-2 d-flex justify-content-end pe-3'>
                        <div className="timeline-input-design">
                            {/* <label >Template Type</label> */}
                            <SuperSearchList
                                type="client"
                                id='Type'
                                name='Type'
                                searchValue={templateTypeDispay}
                                data={TypeDropDownOptions}
                                onChange={(e) => handleChange(e)}
                                getSelectedData={handleSelectedDataa}
                                // is={is}
                                icon={'Simple'}
                                sup_btn='sup_btn'
                                sup_inp='superSearchVisitInp'
                                className="form-control rounded"
                            />
                        </div>
                    </div>
                    {/* </div> */}
                </div>
            </div>

            {isLoading ? <Loader /> : null}
            {show === false ?
                <Table
                    key={templateType === 'Appointments' ? Appointmentcolumns : templateType === 'Forms' ? Formscolumns : templateType === 'Encounter' ? Encountercolumns : Taskcolumns}
                    columns={templateType === 'Appointments' ? Appointmentcolumns : templateType === 'Forms' ? Formscolumns : templateType === 'Encounter' ? Encountercolumns : Taskcolumns}
                    rows={WriteOffData}
                    height='500px'
                    rowClass={rowClass}
                    dynamicClass='fill-grid DataGrid-Table hk-exp-table timline-grid'
                    rowHeight={25}
                    PerPage={PerPage}
                    PageNo={PageNo}
                    TotalPages={TotalPages}
                    Counts={totalCounts}
                    handlePageClick={handlePageClick}
                    PreviousPage={PreviousPage}
                    handleFingByCreteria={handleFingByCreteria}
                    NextPage={NextPage}
                    Key={638}
                    Name={'WriteOffData Codes'}
                    isLoading={isLoading}
                    // TableName={'WriteOffGroup'}
                    handleSelectData={handleSelectData}
                    hideColClass='hide'
                /> : null
            }


        </React.Fragment>
    )
}
const mapStateToProps = (state) => {
    return {
        Settings: state.SettingsReducer,
    }
}
export default connect(mapStateToProps)(TimeLine)